module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"mapButton":"Karte","satelliteButton":"Satellit","noLocation":"Standortdaten fehlen"}}')
  delete Component.options._Ctor
}
